import { requestResetPassword } from '@/auth/auth';
import { Button } from '../../ui/Button';
import Card from '../../ui/Card';
import Flex from '../../ui/Flex';
import { useSession } from '@/context/session/useSession';
import { useState } from 'react';

export default function PasswordCard() {
  const { session } = useSession();
  const [isLoading, setIsLoading] = useState(false);
  const [isSent, setIsSent] = useState(false);

  const handleRequestResetPassword = async () => {
    setIsLoading(true);
    if (session?.user.email) {
      const response = await requestResetPassword(session.user.email!);
      if (response.ok) {
        setIsSent(true);
      }
    }
    setIsLoading(false);
  };

  return (
    <Card isLoading={session === undefined}>
      {session?.user.email && (
        <Flex.Col gap="5">
          <div className="font-semibold">Your password</div>
          <div className="text-secondary">
            To update your password, we’ll send a secure link to your email
            address.
            <br />
            Simply click the link in the email to set a new password.
          </div>
          <Button
            onClick={handleRequestResetPassword}
            className="w-fit"
            disabled={isLoading || isSent}
          >
            {isLoading ? 'Sending...' : isSent ? 'Sent' : 'Request reset password link'}
          </Button>
        </Flex.Col>
      )}
    </Card>
  );
}
